import { CSSResultGroup, TemplateResult, html, nothing } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, state } from 'lit/decorators.js';
import componentStyles from './sic-location-teaser.css.lit';

/**
 * The SicLocationTeaser component
 * @element sic-location-teaser
 * @slot eyebrow - text
 * @slot heading - heading
 * @slot description - text
 * @slot column-1 - text div
 * @slot column-2 - text div
 * @slot column-3 - text div hides below mobile
 */
@customElement('sic-location-teaser')
export class SicLocationTeaser extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @state() hasCol1: boolean;
  @state() hasCol2: boolean;
  @state() hasCol3: boolean;

  protected firstUpdated(): void {
    this.hasCol1 = this.querySelector('[slot="column-1"]') !== null;
    this.hasCol2 = this.querySelector('[slot="column-2"]') !== null;
    this.hasCol3 = this.querySelector('[slot="column-3"]') !== null;
  }

  render(): TemplateResult {
    return html`
      <div class="sic-location-teaser">
        <div class="sic-location-teaser--top-content">
          <slot name="eyebrow"></slot>
          <slot name="heading"></slot>
          <slot name="description"></slot>
        </div>
        <div class="sic-location-teaser--columns">
          ${this.hasCol1
            ? html` <div class="column-wrapper">
                <slot name="column-1"></slot>
              </div>`
            : nothing}
          ${this.hasCol2
            ? html` <div class="column-wrapper">
                <slot name="column-2"></slot>
              </div>`
            : nothing}
          ${this.hasCol3
            ? html` <div class="column-wrapper">
                <slot name="column-3"></slot>
              </div>`
            : nothing}
        </div>
      </div>
    `;
  }
}
